export const IDEALMEDIA_SITE_ID =
  process.env.NEXT_PUBLIC_IDEALMEDIA_INIT?.trim() ||
  process.env.IDEALMEDIA_INIT?.trim() ||
  '1087343';

export const IDEALMEDIA_SITE_SCRIPT_SRC = `https://jsc.idealmedia.io/site/${IDEALMEDIA_SITE_ID}.js`;

const IDEALMEDIA_SITE_SCRIPT_ID = `idealmedia-site-${IDEALMEDIA_SITE_ID}`;

/** @type {Promise<void> | null} */
let loadPromise = null;
/** @type {ReturnType<typeof setTimeout> | null} */
let idealMediaLoadTimer = null;

export function loadIdealMediaSiteScriptOnce() {
  if (typeof document === 'undefined') {
    return Promise.resolve();
  }

  const mounted = document.getElementById(IDEALMEDIA_SITE_SCRIPT_ID);
  if (mounted?.getAttribute('data-idealmedia-loaded') === '1') {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = IDEALMEDIA_SITE_SCRIPT_ID;
    script.src = IDEALMEDIA_SITE_SCRIPT_SRC;
    script.async = true;

    script.addEventListener(
      'load',
      () => {
        script.setAttribute('data-idealmedia-loaded', '1');
        resolve();
      },
      { once: true }
    );
    script.addEventListener(
      'error',
      () => {
        loadPromise = null;
        reject(new Error('Ideal Media site script error'));
      },
      { once: true }
    );

    document.head.appendChild(script);
  });

  return loadPromise;
}

export function ensureIdealMediaSiteAndQueueLoadOnce() {
  return loadIdealMediaSiteScriptOnce().then(() => {
    if (typeof window === 'undefined') {
      return;
    }
    window._mgq = window._mgq || [];
    if (idealMediaLoadTimer) {
      clearTimeout(idealMediaLoadTimer);
    }
    idealMediaLoadTimer = setTimeout(() => {
      idealMediaLoadTimer = null;
      window._mgq = window._mgq || [];
      window._mgq.push(['_mgc.load']);
    }, 50);
  });
}
